import React from 'react'

const Title = ({ event }) => {
  if (typeof event.subtitle !== 'undefined') {
    if (event.subtitle != null) {
      return (
        <>
          <h2>
            <a
              href={event.url}
              className="text-depths no-underline"
            >
              {event.title}
            </a>
          </h2>
          <h3>{event.subtitle}</h3>
        </>
      )
    }
  }
  return (
    <h2>
      <a
        href={event.url}
        className="text-depths no-underline"
      >
        {event.title}
      </a>
    </h2>
  )
}

export default Title
